import styled from 'styled-components'

// Items are not keyboard-focusable by default (plain divs). Navigation is via
// aria-activedescendant on the combobox input — focus never leaves the input.
export const GlobalSearchListItemLayoutStyled = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.space.medium};
  width: 100%;
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(12)} ${props.theme.space.medium}`};
  border: none;
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;

  &:hover,
  &[data-highlighted='true'] {
    background: ${(props) => props.theme.colors.neutral};
  }

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.primary};
    outline-offset: ${(props) => props.theme.typography.pxToRem(-2)};
  }
`
